// ÐÐ¾Ð´ÑÐºÐ°Ð·ÐºÐ¸ Ð² Ð¿Ð¾Ð»Ðµ Â«ÐÐ½Ð°ÑÐµÐ½Ð¸ÐµÂ» Ñ Ð¾Ð¿ÑÐ¸Ð¸ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ â ÑÐ²Ð¾Ð¸ Ñ ÐºÐ°Ð¶Ð´Ð¾Ð¹ ÑÐµÐºÑÐ¸Ð¸,
// ÑÑÐ¾Ð±Ñ Ð±ÑÐ»Ð¾ Ð¿Ð¾Ð½ÑÑÐ½Ð¾, ÑÑÐ¾ Ð¿Ð¸ÑÐ°ÑÑ: Â«ÐÐ°ÑÑÐ¸ÐºÐ¸ Ð¿Ð°ÑÐºÐ¾Ð²ÐºÐ¸Â» â Â«ÐÐ°Ð´Ð½Ð¸ÐµÂ».
export const SAFETY_VALUE_PLACEHOLDER = 'ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ Â«ÐÐ°Ð´Ð½Ð¸ÐµÂ»';
export const EQUIPMENT_VALUE_PLACEHOLDER = 'ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ Â«10,25", Apple CarPlayÂ»';
